import { Box, Step, StepLabel, Stepper, Typography } from '@mui/material';

import type {
  ProvisionPhase,
  ProvisionStreamStatus,
} from '../hooks/useDemoOrgProvisionStream';

interface DemoOrgProvisionProgressProps {
  phases: ProvisionPhase[];
  currentPhase: string | null;
  completedPhases: string[];
  detail: string | null;
  status: ProvisionStreamStatus;
}

/**
 * Vertical phase stepper driven by the demo-org provisioning SSE stream.
 * Completed phases show a check, the active phase shows a spinner (while streaming)
 * plus the live detail line (e.g. "Provisioning associate_1 (3/8)").
 */
export function DemoOrgProvisionProgress({
  phases,
  currentPhase,
  completedPhases,
  detail,
  status,
}: DemoOrgProvisionProgressProps) {
  const activeStep = currentPhase
    ? Math.max(
        0,
        phases.findIndex((p) => p.id === currentPhase),
      )
    : 0;

  return (
    <Box sx={{ mt: 1, mb: 1 }}>
      <Stepper activeStep={activeStep} orientation="vertical">
        {phases.map((phase) => {
          const completed =
            status === 'completed' || completedPhases.includes(phase.id);
          const isActive = phase.id === currentPhase && status !== 'completed';
          return (
            <Step key={phase.id} completed={completed}>
              <StepLabel
                optional={
                  isActive && detail ? (
                    <Typography variant="caption" color="text.secondary">
                      {detail}
                    </Typography>
                  ) : undefined
                }
              >
                {phase.label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
}
